export const Index = r => require.ensure([], () => r(require('./index')), 'fetchcores-bundle');

export default [
  {
    path: 'fetchcores',
    name: 'fetchcores',
    component: Index
  }
];
